import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { PaymentsDataServiceProvider } from '@services/payments/payments-data-service/payments.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { GenericButton, GenericModalContent } from '@models/models';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'write-off-modal',
	template: require('./write-off-modal.html')
})
export class WriteOffModalComponent implements OnInit, OnDestroy {
	@Input() modalContent: GenericModalContent;
	@Input() paymentId;
	@Output() updateParent: EventEmitter<boolean> = new EventEmitter<boolean>();

	disableButton: boolean;
	successButton: GenericButton;
	cancelButton: GenericButton;
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private paymentsDataService: PaymentsDataServiceProvider,
		private messageService: MessageService,
		private activeModal: NgbActiveModal
	) {}

	ngOnInit(): void {
		if (this.modalContent && this.modalContent.buttons) {
			const [successButton, cancelButton] = this.modalContent.buttons;
			this.successButton = successButton;
			this.cancelButton = cancelButton;
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	writeOff(): void {
		this.disableButton = true;
		this.paymentsDataService
			.writeOff(this.paymentId)
			.pipe(
				finalize((): void => {
					this.disableButton = false;
					this.activeModal.close();
				}),
				takeUntil(this.unsubscribe)
			)

			.subscribe(
				(): void => {
					this.updateParent.emit(true);
					this.messageService.showToaster('s_6', 'payments');
				},
				(result): void => this.errorWriteOff(result.error)
			);
	}

	dismissModal(): void {
		this.activeModal.dismiss();
	}

	private errorWriteOff(error): void {
		if (error.errorCode) {
			this.handleModernErrorMessages(error);
			return;
		}
		if (
			error.errorMessage ===
			'Write off feature disabled for copied to QuickBooks invoices'
		) {
			this.messageService.showToaster('e_16', 'qb');
		} else {
			this.messageService.showDefaultErrorMessage(error);
		}
	}

	private handleModernErrorMessages({ errorTitle, errorMessage }): void {
		this.messageService.showErrorFromBackend(errorTitle, errorMessage);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/payments/modals/write-off-modal/write-off-modal.ts